import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';

export class ChangePassword implements EntityInterface {
    previousPassword: string;
	newPassword: string;
}
